import { memo } from "react";
import { Tooltip } from "../../UI";
import ModuleIcon from "../ModuleIcon";
import {
  StyledBookmarkContainer,
  StyledModuleBox,
  StyledModuleBoxBody,
  StyledModuleDescriptionContainer,
  StyledModuleTitle,
} from "../Modules-styled";

const Bookmark = ({ ...props }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 512 512"
      height="16px"
      width="16px"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
        d="M352 48H160a48 48 0 0 0-48 48v368l144-128 144 128V96a48 48 0 0 0-48-48z"
      ></path>
    </svg>
  );
};

const ModuleBox = ({
  module,
  selectedModule,
  handleModuleClick,
  handleBookmarkClick,
  t,
}) => {
  return (
    <StyledModuleBox
      color={module.color}
      onClick={handleModuleClick}
      key={module.moduleName}
    >
      <StyledModuleTitle>{module.moduleName}</StyledModuleTitle>
      <StyledModuleBoxBody>
        <StyledModuleDescriptionContainer>
          <span>{module.title}</span>
        </StyledModuleDescriptionContainer>
        <StyledBookmarkContainer onClick={handleBookmarkClick}>
          <Tooltip
            content={t("screen.widget.ModuleSwitcher.bookmarkTooltip")}
            showOnHover
            placement="top"
            blurred
            zIndex={21}
          >
            <Bookmark
              fill={module.module === selectedModule ? "#fff" : module.color}
              className="bookmark"
            />
          </Tooltip>
        </StyledBookmarkContainer>
        <ModuleIcon
          className="module-icon-holder"
          opsColor={module.color}
          module={module.module}
        />
      </StyledModuleBoxBody>
    </StyledModuleBox>
  );
};

export default memo(ModuleBox);
